import { t, translate } from '@avalara/bat-apps-shared/i18n';
import { SContainer } from '@avalara/skylab-sdk/react';
import conf from '../conf';

const HomePage = () => {
  // Construct image path: if ASSET_PATH is empty, use absolute path from root
  // const imagePath = conf.ASSET_PATH
  //   ? `${conf.ASSET_PATH}/assets/images/store-homepage-img.png`
  //   : '/assets/images/store-homepage-img.png';

  return (
    <SContainer>
      <div
        style={{ marginTop: '50px', justifyContent: 'space-evenly' }}
        className='flex flex-dir-row align-items-center'
      >
        <div>
          <img src={`${conf.ASSET_PATH}/assets/images/store-homepage-img.png`} alt='store-homepage' />
        </div>
        <div>
          <h2 className='font-normal pad-bottom-sm'>{t('client.headings.thanks-for-your-interest-in-avalara')}</h2>
          <p className='pad-bottom-sm'>
            {translate('client.general.dedicated-team-call-us-at-phone-to-get-started', {
              phoneLink: (chunks) => (
                <a href={'tel://(877) 224-3650'} style={{ color: 'var(--color-blue-darker)' }}>
                  {chunks}
                </a>
              ),
            })}
          </p>
        </div>
      </div>
    </SContainer>
  );
};

export default HomePage;
